import { Component } from "@angular/core";

@Component({
  selector: 'matches-app',
  template: `<router-outlet></router-outlet>`,  
})

export class MatchesComponent {
    constructor() {}
}